import cn from 'classnames/bind';
import React from 'react';

import styles from './term.module.scss';

const cx = cn.bind(styles);

export const Term: React.FC<{
  term: number;
  selectedTerm: number;
  onClick: () => void;
}> = ({ term, selectedTerm, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={cx(styles.term, {
        termSelected: term === selectedTerm,
      })}
    >
      {term}
    </button>
  );
};
